import API from '../API';
import appConfig from '../../config/appConfig';
import {
  IAdminUpdateCommunityRequestBody,
  IPendingCommunitiesResponseBody,
  IFilterRequestParams,
  ICommunityDetailsResponseBody,
  ITokensRequestsResponseBody,
  IIssueTokensUpdateRequest,
  IIssueTokens,
} from 'types';

const adminCommunitiesAPI = {
  getPendingCommunities(params: IFilterRequestParams): Promise<IPendingCommunitiesResponseBody> {
    return API.get<IPendingCommunitiesResponseBody>(`${appConfig.serviceUrl}/api/admin/communities`, {
      params,
    }).then((response) => response.data);
  },

  updateCommunity(communityId: string | number, body: IAdminUpdateCommunityRequestBody): Promise<void> {
    return API.put<IAdminUpdateCommunityRequestBody, void>(
      `${appConfig.serviceUrl}/api/admin/communities/${communityId}`,
      body,
    ).then((response) => response.data);
  },

  deleteCommunity(communityId: number) {
    return API.delete<void>(`${appConfig.serviceUrl}/api/admin/communities/${communityId}`).then(
      (response) => response.data,
    );
  },

  checkIsCanDelete(communityId: number) {
    return API.get<boolean>(`${appConfig.serviceUrl}/api/admin/communities/${communityId}/can-delete`).then(
      (response) => response.data,
    );
  },

  markForDeletion(communityId: number, body: { markedForDeletion: boolean }): Promise<void> {
    return API.patch<{ markedForDeletion: boolean }, void>(
      `${appConfig.serviceUrl}/api/admin/communities/${communityId}/mark-for-deletion`,
      body,
    ).then((response) => response.data);
  },

  getCommunityById(communityId: string | number): Promise<ICommunityDetailsResponseBody> {
    return API.get<ICommunityDetailsResponseBody>(`${appConfig.serviceUrl}/api/admin/communities/${communityId}`).then(
      (response) => response.data,
    );
  },

  getTokensRequests(params: IFilterRequestParams): Promise<ITokensRequestsResponseBody> {
    return API.get<ITokensRequestsResponseBody>(`${appConfig.serviceUrl}/api/admin/communities/issue-tokens-requests`, {
      params,
    }).then((response) => response.data);
  },

  getCommunityTokenRequest(id: number): Promise<IIssueTokens> {
    return API.get<IIssueTokens>(`${appConfig.serviceUrl}/api/admin/communities/issue-tokens-requests/${id}`).then(
      (response) => response.data,
    );
  },

  updateTokenRequest(tokenRequestId: number, body: IIssueTokensUpdateRequest): Promise<IIssueTokens> {
    return API.put<IIssueTokensUpdateRequest, IIssueTokens>(
      `${appConfig.serviceUrl}/api/admin/communities/issue-tokens-requests/${tokenRequestId}`,
      body,
    ).then((response) => response.data);
  },
};

export default adminCommunitiesAPI;
